@use 'styles/mixins';
@use 'styles/variables';

.Buttons {
  display: flex;
  justify-content: flex-end;

  &_WithMargin {
    margin-top: 5rem;
  }

  &_Button {
    min-width: 12.4rem;

    &:last-child {
      margin-left: 1.6rem;
    }
  }
}

.Box {
  display: flex;
  gap: 1rem;
  flex-direction: row;
  justify-content: flex-end;
}

@include mixins.forScreen(
  variables.$mobile-small-width,
  variables.$tablet-width - 1
) {
  .Buttons {
    justify-content: center;

    &_Button {
      width: 100%;
    }
  }
}
